module.exports = __webpack_public_path__ + "img/header-newsletteranmeldung@2x.56078e4f.png";